import { useEffect } from "react";
import Smartlook from "smartlook-client";
import { useDriverDetails, useUserDetails } from "./useSupervisorDetails";

const useSmartlook = () => {
  const userDetails = useUserDetails();
  const driverDetails = useDriverDetails();

  useEffect(() => {
    if (typeof window !== "undefined") {
      Smartlook.init(import.meta.env.VITE_SMARTLOOK_KEY, { region: "eu" });

      // Allow recording of specific types of data
      Smartlook.record({
        forms: true,  // Enable recording of form inputs
        numbers: true  // Enable recording of phone numbers
      });
    }

    if (userDetails) {
      const userInfo = {
        id: userDetails.id as string,
        email: userDetails.email as string,
        name: userDetails.name as string,
        phone: userDetails.phone as string,
      };
      Smartlook.identify(userDetails.phone as string, userInfo);
    }
    else if (driverDetails)
    {
      const userInfo = {
        id: driverDetails.data.user.id as string,
        email: driverDetails.data.user.email as string,
        name: driverDetails.data.user.name as string,
        phone: driverDetails.data.user.phone as string,
      };
      Smartlook.identify(driverDetails.data.user.phone as string, userInfo);
    }
  }, [userDetails, driverDetails]);

  return null; // Since it doesn't render anything, return null
};

export default useSmartlook;